<template>
  <div class="section section3">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>资源匹配 精准对接
      <a href="####" class="tit-more more-link" >更多</a>
    </h2>
    <div class="subnav" :style="showTab?'':'display:none;'">
      <ul class="navbox" v-show="showTab">
        <li :class="{active: selected === 'kanzhengce'}">
          <a @click.prevent="onQueryData('kanzhengce')" href="####看政策" class="fs-rem28">
            看政策
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'chaxiangmu'}">
          <a @click.prevent="onQueryData('chaxiangmu')" href="####查项目" class="fs-rem28">
            查项目
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'pindanbao'}">
          <a @click.prevent="onQueryData('pindanbao')" href="####聘专家" class="fs-rem28">
            聘专家
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'chuangbiaozhun'}">
          <a @click.prevent="onQueryData('chuangbiaozhun')" href="####创标准" class="fs-rem28">
            创标准
            <i class="hr"></i>
          </a>
        </li>
        <!-- <li :class="{active: selected === 'zhaozijin'}">
          <a @click.prevent="onQueryData('zhaozijin')" href="####找资金" class="fs-rem28">
            找资金
            <i class="hr"></i>
          </a>
        </li>
        <li :class="{active: selected === 'huodanbao'}">
          <a @click.prevent="onQueryData('huodanbao')" href="####获得担保" class="fs-rem28">
            获担保
            <i class="hr"></i>
          </a>
        </li> -->
        <li>
          <a @click="$router.push('/project-find')" href="####更多" class="c-blue fs-rem28">更多</a>
        </li>
      </ul>
    </div>
    <div class="w1200 data-container">
      <div class="sec3-list">
        <ul class="list-box">
          <li v-for="project in projects" :key="project.pid" class="lst-item">
            <span class="fs14 fs-rem24 lst-tit line-limit-length">{{project.title}}</span>
            <span class="fs14 fs-rem18 lst-time">{{`${formatT(project.createTime)}`}}</span>
            <a :href="project.url" class="fs14 fs-rem24 lst-btn">查看详情</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- /资源匹配 -->
</template>

<script>
import {
  queryProjects
} from '@/api/main';
import {getStaticInfo} from '@/utils/auth.js'
import GetStaticIndexMixin from '@/mixins/GetStaticIndex.mixin.js'
import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'

export default {
  mixins: [GetStaticIndexMixin],
  name: 'SourceMatch',
  props: {
    msg: String,
    showTab:Boolean,
    projectList:Array,
  },
  data() {
    return {
      projects: [],
      selected: 'kanzhengce'
    }
  },
  mounted() {

  },
  methods: {
    p_init(){
      if(this.projectList&&this.projectList){
        this.projects = this.projectList
      }else{
        this.initData('pipei')
        this._queryProjects();
      }
    },
    formatT(ts){
      return this.formatTime(ts)
    },
    resetData() {
      this.projects = [];
    },
    onQueryData(tid) {
      if (tid === 'more') {
        // 点击跳转更多
        return;
      }
      this.resetData();
      this.selected = tid;
      this._queryProjects();
    },
    _queryProjects() {
      // this.$http.get(queryProjects()).then((res) => {
      //   this.projects = res.data;
      //   console.log(res, '>queryProjects');
      // });
      this.projects = this.StaticIndexs[this.selected]
      // console.log('SourceMatch------>',this.StaticIndexs)
    },
    onJoinIn(project) {
      console.log('快速报名', project);
    }
  }
};
</script>

<style>
@import url(./SourceMatch.css);
</style>
